import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_956wcc3gjb: FaireBrandEntity = {
  token: "b_956wcc3gjb",
  type: "brand",
  name: "The Toy Network",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ae990aeaf332de4e512b327c16318b2910941e11c798bdde16300b96b7373b0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6e0180de9661c9c1ca8a3b9f7f91485bdb7a09a3769c0b77760c2c2eb666e2d7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9ae990aeaf332de4e512b327c16318b2910941e11c798bdde16300b96b7373b0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6e0180de9661c9c1ca8a3b9f7f91485bdb7a09a3769c0b77760c2c2eb666e2d7.jpeg",
  location: "Fall River, MA, USA",
  minimumOrderDollars: 250,
  rating: 4.7,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Hello and welcome to The Toy Network. We’re a family-owned and operated toy company based in historic Fall River, Massachusetts. We began The Toy Network in 2018 with a focus on the specialty toy & gift channel and we now offer more than 4,000 trendy, impulse novelties, as well as classic, traditional toys, plush, and candy. \n\nIn 2024 we acquired the exclusive distribution rights to the 4M Science and STEAM brand for the toy specialty & gift channel. This highly awarded, global brand is constantly creating and innovating new and exciting price sensitive home schooling aids, robotic building kits, eco-friendly scientific topics, as well as art and creativity. 4M adds more than 20 new items to it's line each and every year. We're excited to bring this line to Faire and hope you and your customers will enjoy it too! Check out one of our best selling 4M items; the metal detector!\n\nOver the past several years, we have been committed to reducing our environmental footprint. Nothing speaks to this more than the 8800 solar panels that cover the roof of our warehouse and provides 130% of electrical needs for the 620,000sq ft building.  Our facility has been awarded with a Silver LEED Certification and ENERGY STAR Certification, identifying us as a business leader in green facilities. Furthermore, we're happy to report that our shipping is certified  as \"Carbon Neutral\" through our carbon-offsetting strategies.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:02.742Z",
    importedBy: "entity-db-cli",
  },
};
